import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx } from "@emotion/react";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function Loader(props) {
  return (
    <div
      css={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      className="centered-container"
      {...props}
    >
      <CircularProgress size={50} color="primary" />
    </div>
  );
}
